export default __webpack_public_path__ + "static/slider-1-04e9e52538188e6712b6ce887110115c.jpg";